import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import RegistrationFunnel from "@/pages/RegistrationFunnel";
import ThankYou from "@/pages/ThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import VisitorRegistration from "@/pages/VisitorRegistration";
import VisitorThankYou from "@/pages/VisitorThankYou";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App grain">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/apply" element={<RegistrationFunnel />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/visitor" element={<VisitorRegistration />} />
            <Route path="/visitor/thank-you" element={<VisitorThankYou />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
